/**
 * Terminal component types and interfaces
 */

export type TerminalState = 
  | { type: 'idle' }
  | { type: 'initializing' }
  | { type: 'connecting' }
  | { type: 'connected'; sessionId: string }
  | { type: 'error'; message: string; retryable: boolean }
  | { type: 'disconnected'; reason?: string };

export interface TerminalConfig {
  sessionId: string;
  instanceId?: string;
  provider?: 'aws' | 'gcp' | 'azure';
  instanceType?: string;
  region?: string;
  standalone?: boolean;
}

export interface TerminalMethods {
  connect: () => void;
  disconnect: () => void;
  sendInput: (data: string) => void;
  clear: () => void;
  resize: (cols: number, rows: number) => void;
  focus: () => void;
}

export interface TerminalTheme {
  background: string;
  foreground: string;
  cursor: string;
  cursorAccent: string;
  selectionBackground: string;
  selectionForeground: string;
  black: string;
  red: string;
  green: string;
  yellow: string;
  blue: string;
  magenta: string;
  cyan: string;
  white: string;
  brightBlack: string;
  brightRed: string;
  brightGreen: string;
  brightYellow: string;
  brightBlue: string;
  brightMagenta: string;
  brightCyan: string;
  brightWhite: string;
}

export interface WebSocketMessage {
  type: 'input' | 'resize' | 'ping';
  data?: string;
  cols?: number;
  rows?: number;
  timestamp?: number;
}

export interface WebSocketResponse {
  type: 'connected' | 'output' | 'error' | 'pong';
  data?: string;
  message?: string;
  timestamp?: number;
}

export const DEFAULT_TERMINAL_THEME: TerminalTheme = {
  background: 'rgba(0, 0, 0, 0.85)',
  foreground: '#ffffff',
  cursor: '#60a5fa',
  cursorAccent: '#1e1e1e',
  selectionBackground: 'rgba(96, 165, 250, 0.3)',
  selectionForeground: '#ffffff',
  black: '#000000',
  red: '#ef4444',
  green: '#10b981',
  yellow: '#fbbf24',
  blue: '#3b82f6',
  magenta: '#a78bfa',
  cyan: '#06b6d4',
  white: '#f8fafc',
  brightBlack: '#4b5563',
  brightRed: '#f87171',
  brightGreen: '#34d399',
  brightYellow: '#fde047',
  brightBlue: '#60a5fa',
  brightMagenta: '#c084fc',
  brightCyan: '#22d3ee',
  brightWhite: '#ffffff'
};